import { useState } from "react";

import Modal, { ModalProps } from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {
	ChildBirthByCityAndTypeResume,
	ChildBirthByCityAndTypeTable,
} from "../ChildBirthByCityAndTypeTable";
import { ChildBirthByCityAndTypeTableFilters } from "../ChildBirthByCityAndTypeTableFilters";

type Props = ModalProps & {
	childBirthByCityAndTypeResumes: ChildBirthByCityAndTypeResume[];
};

export function ChildBirthByCityAndTypeModal({ childBirthByCityAndTypeResumes, ...rest }: Props) {
	const [cityName, setCityName] = useState("");
	const childBirthByCityAndTypeResumesFiltered = childBirthByCityAndTypeResumes.filter((resume) =>
		resume.city.locale.toUpperCase().includes(cityName.toUpperCase())
	);
	return (
		<Modal {...rest} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
			<Modal.Header closeButton>
				<Modal.Title>
					<h3 className="text-uppercase text-dark fw-bold fs-1">
						PARTOS POR CIDADE E TIPO
					</h3>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row>
					<Col>
						<ChildBirthByCityAndTypeTableFilters
							cityName={cityName}
							setCityName={setCityName}
						/>
					</Col>
				</Row>
				<ChildBirthByCityAndTypeTable
					childBirthByCityAndTypeResumes={childBirthByCityAndTypeResumesFiltered}
				/>
			</Modal.Body>
		</Modal>
	);
}
